module.exports = __webpack_public_path__ + "assets/img/play.42454b31.svg";